import React, { Component } from 'react';
import './DefaultComp.scss';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ToggleButton from '../../Elements/Molecules/ToggleButton';
import { getGenericData, makeBotCustom, blockUiFun, getSelectedBotData, upsertBotConfigData, resetVersion, getBotInfo } from '../../Redux/Actions/uiActions';
import { bindActionCreators } from "redux";
import history from '../../Routers/history';
import { Modal } from "react-ui-lib";

const generatePrefix = ()=> {
    let default_set = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let default_id_length = 6;
    let prefix = process.env?.REACT_APP_LS_PREFIX || '_t_';

    let generateShortUniqueId = (length = default_id_length, characterSet = default_set) => {
        let id = '';

        Array.from({ length }).forEach(() => {
            const randomIndex = Math.floor(Math.random() * characterSet.length);
            id += characterSet.charAt(randomIndex);
        });

        return prefix + id;
    }
    return generateShortUniqueId();
}

class DefaultComp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            botDetail: {},
            currentEditableBotData: {},
            isOpen: false,
            togglerState: false
        }

        this.toggleButtonRef = React.createRef();
    }

    componentDidMount() {
        this.botId = this.props.location.pathname.split('/')[1];
        
        if(this.botId === 'bot-list') return;
        
        this.props.blockUiFun(true);
        if(!localStorage.getItem('bot_id')) {
            localStorage.setItem('bot_id', this.botId);
        } else {
            this.botId = localStorage.getItem('bot_id');
            history.replace(`${this.botId}/`)
        }
        getBotInfo(this.botId);
        this.props.getSelectedBotData(this.botId,() => {
            setTimeout(() => {this.props.blockUiFun(false);}, 3000);
        },() => {
            this.props.blockUiFun(false);
        });
    }

    UNSAFE_componentWillReceiveProps(nextProp) {
        this.botId = this.props.location.pathname.split('/')[1];
        if(nextProp.availableBotList.length) {
            nextProp.availableBotList.forEach(element => {
                if(this.botId === element.id) {
                    this.setState({botDetail: element});
                    return
                }
            });
            this.setState({currentEditableBotData: nextProp.editableBotData});
        }
    }

    onsubmitCallback = () => {
        this.props.blockUiFun(true);
        let currLang = this.props.currentLanguage === 'omni' ? process.env.DEFAULT_BOT_LANG || 'de' : this.props.currentLanguage;
        this.props.getGenericData(currLang, (res) => {
            // let tempBotData = Object.keys(this.props.genericBotData).length ? this.props.genericBotData : this.props.editableBotData;
            let tempBotData = JSON.parse(JSON.stringify(res));
            tempBotData.CUSTOM_BOT_UI.VALUE = true;
            if(tempBotData) {
                if(tempBotData._id) {
                    delete tempBotData._id;
                }
                if(tempBotData.endpoint) {
                    delete tempBotData.endpoint;
                }
                if(tempBotData.langISO) {
                    delete tempBotData.langISO;
                }
                if(tempBotData.botId) {
                    tempBotData.botId = this.props.selectedBotID;
                }
                if(tempBotData.SETTINGS) {
                    let tempBotElmData = {
                        "ELEM_TYPE": "text-field",
                        "ELEM_DESC": "BotID for ui",
                        "VALUE": this.props.selectedBotID
                    }
                    tempBotData.SETTINGS.BOTID = tempBotElmData;
                    tempBotData.SETTINGS.BOT_LANG.VALUE = this.props.currentLanguage;
                    tempBotData?.CHATBOT?.TESTING_PAGE_SETTINGS?.PAGE_TITLE ? tempBotData.CHATBOT.TESTING_PAGE_SETTINGS.PAGE_TITLE.VALUE = "Custom Bot" : null;
                    tempBotData?.UI_OPTIONS?.USER_SIDE_SETTINGS?.LS_PREFIX ? tempBotData.UI_OPTIONS.USER_SIDE_SETTINGS.LS_PREFIX.VALUE = generatePrefix() : null;
                }
                tempBotData.sourceLangISO = currLang;
                tempBotData.sourceName = "webpage";
                tempBotData.isDefault = true;
            }
            this.toggleModal();
            setTimeout( () => {
                this.props.upsertBotConfigData(tempBotData, this.props.version, () => {
                    this.props.resetVersion();
                    // this.props.blockUiFun(false);
                    this.setState({modalState: 'save'},() => {
                        // this.props.blockUiFun(true);
                        // localStorage.setItem('bot_id', this.props.selectedBotID);
                        this.props.getSelectedBotData(this.props.selectedBotID,() => {
                            // setTimeout(() => {this.props.blockUiFun(false);}, 3000);
                            setTimeout( () => {
                                this.props.blockUiFun(false);
                                this.props.makeBotCustom(true);
                                history.push(`/${this.props.selectedBotID}/chatbot`)
                            }, 1000);
                        },() => {
                            this.props.blockUiFun(false);
                        });
                    });
            }), 100})
        }, (err) => {
            console.log('err', err);
            this.props.blockUiFun(false);
        })
    }

    onCancelCallback = () => {
        this.toggleModal();
    }

    toggleModal = (currState = true) => {
        const { isOpen } = this.state;
        if (!currState) {
            document.getElementsByTagName('body')[0].style.overflow = 'auto';
            this.setState({ isOpen: false });
        } else {
            document.getElementsByTagName('body')[0].style.overflow = isOpen
                ? 'auto'
                : 'hidden';
            this.setState(prevState => ({
                isOpen: !prevState.isOpen
            }));
            if(isOpen) {
                this.setState({
                    togglerState: false
                });
            }
        }
    };

    renderContent = () => {
        return (
            <div className = 'modal-body-content'>
                Are you sure to make this generic bot as Custom bot ?
            </div>
        );
    };

    render() {
        const labelValue = (this.state.botDetail.displayName || 'Selected bot') + ' is not Custom'; 

        const { isOpen } = this.state;
        const header = {
            title: 'Confirmation Message',
            closeOnOutsideClick: false,
            isRemoveCloseIcon : true,  // send if needed to hide close icon on header
            style: {}
        };
        const footer = {
            onSubmit: this.onsubmitCallback,
            onCancel: this.onCancelCallback,
            submitText: 'Confirm',
            cancelText: 'Cancel',
            customStyle: {
                justifyContent: 'flex-end'
            },
            disableSubmit: false,
            disableCancel: false
        };
        const customStyle = {
            maxWidth: '600px'
        };
        return (
            <div className = 'tab-pane fade active in show' id='makingBotCustomContainer'>
                <div className = 'tab-section-wrapper bot-custom-tab'>
                    <div className = 'tab-header-wrapper'>
                        <h3 className = 'tab-header'> Make Bot Custom</h3>
                        <div className = 'container-fluid single-inputs-wrapper no-padding' key = {this.state.togglerState}>
                            <label className = 'hint-text-toggler' ref = {this.toggleButtonRef}>Please toggle the button to make bot custom</label> 
                            <ToggleButton
                                className = 'switch-toggle-wrapper go-float-left'
                                childId = 'make-custom'
                                inputName = 'set-name'
                                inputClassName = 'inputClassName'
                                labelValue = {labelValue}
                                labelClassName = 'switch-label'
                                togglerState = {this.state.togglerState}
                                toggleClicked = {(e) => {
                                    this.toggleModal();
                                    this.setState({
                                        togglerState: !this.state.togglerState
                                    });
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className = 'confirm-message-modal-container test'>
                    <Modal
                        isOpen={isOpen}
                        onClose={() => {this.toggleModal(false)}}
                        header={header}
                        footer={footer}
                        customStyle={customStyle}
                    >
                        {this.renderContent()}
                    </Modal>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        selectedBotID: state.UiReducer && state.UiReducer.selectedBotID ? state.UiReducer.selectedBotID : false,
        selectedBot: state.UiReducer && state.UiReducer.selectedBot && (state.UiReducer.selectedBot !== 'Select Bot') ? state.UiReducer.selectedBot : false,
        editableBotData: state.UiReducer && state.UiReducer.editableBotData ? state.UiReducer.editableBotData : false,
        genericBotData: state.UiReducer && state.UiReducer.genericBotData ? state.UiReducer.genericBotData : {},
        currentLanguage: state.UiReducer && state.UiReducer.currentLanguage ? state.UiReducer.currentLanguage : 'en',
        version: state.UiReducer && state.UiReducer.version ? state.UiReducer.version : '',
        availableBotList: state.UiReducer && state.UiReducer.availableBotList ? state.UiReducer.availableBotList : []
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        getGenericData,
        makeBotCustom,
        blockUiFun,
        getSelectedBotData,
        upsertBotConfigData,
        resetVersion,
        getBotInfo
    },
        dispatch
    );
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(DefaultComp));